export type QualityPreset = "low" | "medium" | "high" | "ultra";

export const CONFIG = {
  title: "HALYARD",
  subtitle: "TERMINAL 9",
  studio: "AEGIR RESPONSE",
  enemyFaction: "VESPER COMPANY",

  worldFov: 74,
  adsFov: 58,
  eyeHeight: 1.64,
  crouchEye: 0.98,
  radius: 0.38,
  standHeight: 1.78,
  crouchHeight: 1.08,

  walkSpeed: 4.55,
  sprintSpeed: 7.15,
  crouchSpeed: 2.15,
  slideSpeed: 9.4,
  accel: 18,
  airAccel: 3.2,
  friction: 9.5,
  gravity: 22,
  jumpSpeed: 7.6,
  slideMinSpeed: 6.2,

  mouseSens: 0.00215,
  adsSensMul: 0.72,

  health: 100,
  armor: 50,
  regenDelay: 4.0,
  regenPerSec: 22,

  colors: {
    paper: 0xe8e2d6,
    ink: 0x07080a,
    signal: 0xff4d2e,
    sodium: 0xffb347,
    led: 0x7ec8e3,
    visor: 0xff2a2a,
    ally: 0x8fdfb0,
  },
};

export const QUALITY: Record<
  QualityPreset,
  {
    pixelRatio: number;
    shadows: boolean;
    shadowSize: number;
    ao: boolean;
    bloom: boolean;
    reflector: boolean;
    rain: number;
    particles: number;
    pointLights: number;
    grain: boolean;
    ca: boolean;
  }
> = {
  low: {
    pixelRatio: 1,
    shadows: false,
    shadowSize: 512,
    ao: false,
    bloom: false,
    reflector: false,
    rain: 400,
    particles: 80,
    pointLights: 3,
    grain: false,
    ca: false,
  },
  medium: {
    pixelRatio: 1.25,
    shadows: true,
    shadowSize: 1024,
    ao: false,
    bloom: true,
    reflector: false,
    rain: 900,
    particles: 160,
    pointLights: 5,
    grain: true,
    ca: false,
  },
  high: {
    pixelRatio: 1.5,
    shadows: true,
    shadowSize: 2048,
    ao: true,
    bloom: true,
    reflector: true,
    rain: 1600,
    particles: 280,
    pointLights: 8,
    grain: true,
    ca: true,
  },
  ultra: {
    pixelRatio: 2,
    shadows: true,
    shadowSize: 2048,
    ao: true,
    bloom: true,
    reflector: true,
    rain: 2400,
    particles: 420,
    pointLights: 10,
    grain: true,
    ca: true,
  },
};
